/*
 * Copyright © 2026. Legalbird eine Marke der Legalbird GmbH
 */

import { Components, Theme } from "@mui/material/styles";

export const muiTabsStyle = (theme: Theme): Components<Theme>["MuiTabs"] => ({
  styleOverrides: {
    indicator: {
      backgroundColor: theme.palette.secondary.main,
    },
  },
});
